export default __webpack_public_path__ + "static/Textile-efdc8d4c11125a7cd6b4dc528408c153.jpg";